import { createFileRoute, redirect } from '@tanstack/react-router'
import { CycleList } from '@/features/hr-performance/cycle-list'
import { hasGrant } from '@/lib/me'

/**
 * Route shell for the performance screen (cycle-first home), following
 * `routes/_authenticated/users.tsx`.
 *
 * The grant guard is presentation only. The API enforces `performance.view` on
 * every review endpoint and narrows the list to the three parties a review has
 * — the employee, the reviewer, and HR — so a stale grant still 403s
 * server-side; this only keeps a user without the grant out of a screen they
 * cannot use.
 *
 * Per the route-shell rule in `apps/company/AGENTS.md`, this file is a route
 * definition, a guard and a render. The screen lives in
 * `src/features/hr-performance/`.
 */
export const Route = createFileRoute('/_authenticated/hr/performance/')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'performance.view')) {
      throw redirect({ to: '/' })
    }
  },
  component: CycleList,
})
